import { WidgetBaseOption, WidgetQuery } from './widget.options';

export enum WidgetGridType {
    Report = 'report'
}

export interface WidgetGridOption extends WidgetBaseOption {
    type: WidgetGridType,

    query?: WidgetQuery,
    visualization: WidgetGridVisualization,
}

export interface WidgetGridVisualization {
    dataId: string | null;
}

// DATA 
